import { render, staticRenderFns } from "./StoreGroupbuyingCreate.vue?vue&type=template&id=1fa95878&scoped=true&"
import script from "./StoreGroupbuyingCreate.vue?vue&type=script&lang=js&"
export * from "./StoreGroupbuyingCreate.vue?vue&type=script&lang=js&"
import style0 from "./StoreGroupbuyingCreate.vue?vue&type=style&index=0&id=1fa95878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa95878",
  null
  
)

export default component.exports